// Asset-free ringtone + notification tones via the Web Audio API. No binary assets to ship,
// no CSP/asset-pipeline concerns — the ring cadence is synthesised.
//
// Browser autoplay policy: an AudioContext may start "suspended" until a user gesture. By
// the time a doctor is on the console they've clicked through login, so resume() succeeds;
// if it doesn't, we fail silently (the incoming-call MODAL still shows — sound is a bonus).

let ctx = null;
let ringTimer = null;

function audioCtx() {
  if (ctx) return ctx;
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  } catch (_) {
    ctx = null;
  }
  return ctx;
}

// One "brring" — a short two-tone warble like a desk phone.
function playRingBurst() {
  const ac = audioCtx();
  if (!ac) return;
  try {
    if (ac.state === "suspended") ac.resume();
    const now = ac.currentTime;
    const gain = ac.createGain();
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.18, now + 0.05);
    gain.gain.setValueAtTime(0.18, now + 0.9);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 1.0);
    gain.connect(ac.destination);

    [440, 480].forEach((freq) => {
      const osc = ac.createOscillator();
      osc.type = "sine";
      osc.frequency.setValueAtTime(freq, now);
      osc.connect(gain);
      osc.start(now);
      osc.stop(now + 1.0);
    });
  } catch (_) {
    /* ignore */
  }
}

// Start looping the ring (burst, then repeat every 3s) until stopRing().
export function startRing() {
  stopRing();
  playRingBurst();
  ringTimer = setInterval(playRingBurst, 3000);
}

export function stopRing() {
  if (ringTimer) {
    clearInterval(ringTimer);
    ringTimer = null;
  }
}

// A short, single "ding" for non-call notifications (e.g. a new appointment request).
export function playNotify() {
  const ac = audioCtx();
  if (!ac) return;
  try {
    if (ac.state === "suspended") ac.resume();
    const now = ac.currentTime;
    const gain = ac.createGain();
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.15, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.35);
    gain.connect(ac.destination);
    const osc = ac.createOscillator();
    osc.type = "sine";
    osc.frequency.setValueAtTime(880, now);
    osc.frequency.exponentialRampToValueAtTime(1320, now + 0.12);
    osc.connect(gain);
    osc.start(now);
    osc.stop(now + 0.36);
  } catch (_) {
    /* ignore */
  }
}
